/**
 * 表示モード（カスタマー画面のみで利用する）
 * - バイヤー
 * - サプライヤー
 */
export const UserDisplayMode = {
  BUYER: 'buyer',
  SUPPLIER: 'supplier',
} as const

export type UserDisplayMode =
  (typeof UserDisplayMode)[keyof typeof UserDisplayMode]

/**
 * 表示モードであるか
 * @param value 任意の値
 * @returns boolean
 */
export const isUserDisplayMode = (value: unknown): value is UserDisplayMode => {
  return Object.values(UserDisplayMode).includes(value as any)
}
